/* eslint-disable no-relative-import-paths/no-relative-import-paths */
import React from "react";
import { Container, createRoot } from "react-dom/client";
import { App } from "./app";
import "./global.css";
// Initialize Branch SDK as early as possible
import { branchManager } from "./core/branch/branch-manager";

// Fire-and-forget; ensures the script is requested immediately
void branchManager.init(process.env.BRANCH_KEY);

// Guard against external DOM mutations (e.g., browser auto-translation) causing NotFoundError on removeChild
const originalRemoveChild = Node.prototype.removeChild;
Node.prototype.removeChild = function <T extends Node>(child: T): T {
	try {
		return originalRemoveChild.call(this, child) as T;
	} catch (error) {
		if (error instanceof DOMException && error.name === "NotFoundError") {
			if (child.parentNode && child.parentNode !== this) {
				return child;
			}
			if (!child.parentNode) {
				return child;
			}
		}
		throw error;
	}
};

const root = createRoot(document.getElementById("react-root") as Container);
root.render(<App />);
